import Avatar from './avatar';

const settings = {
    template: `<div class="audio-tooltip-button">
            <button class="audio-tooltip-button__prompt"></button>
        </div>`,

    classNames: {
        visible: 'audio-tooltip--visible',
    },

    selectors: {
        buttonPrompt: '.audio-tooltip-button__prompt',
    },

    animation: {
        showAvatarDuration: 1.0,
        showPromptDuration: 0.5,
        showPromptDelay: 0.25,
        hideDuration: 0.375,
        slowMoScale: 1 / 4,
    },
};

export default class Button {
    constructor(
        prompt,
        clickCallback,
    ) {
        /** @type {boolean} */
        this.isVisible = false;

        // Create our button element
        /** @type {Element} */
        this.container = document.createElement('div');
        this.container.innerHTML = settings.template;
        this.container = this.container.firstChild;

        // Add our prompt
        /** @type {Element} */
        this.buttonPrompt = this.container
            .querySelector(settings.selectors.buttonPrompt);
        this.buttonPrompt.appendChild(prompt);

        // Create and add our avatar
        this.avatar = new Avatar();
        this.container.appendChild(this.avatar.container);

        // Setup our click callback
        if (clickCallback) {
            this.container.addEventListener('click', clickCallback);
        }

        // Add our element to the DOM
        document.body.appendChild(this.container);
    }

    show(
        delay = 0,
        immediate = false,
        slowMo = false,
    ) {
        if (this.isVisible) {
            return;
        }

        this.isVisible = true;

        // Stop any ongoing animation
        if (this.showHideTimeline) {
            this.showHideTimeline.progress(1);
        }

        // Add our "visible" class
        this.container.classList.add(settings.classNames.visible);

        if (immediate) {
            // Stop here
            return;
        }

        // Animate transition
        this.showHideTimeline = gsap.timeline();
        if (slowMo) {
            this.showHideTimeline.timeScale(settings.animation.slowMoScale);
        }

        this.avatar.createShowAnimation(
            this.container,
            this.showHideTimeline,
            settings.animation.showAvatarDuration,
            delay,
        );

        // Edit: this is a small slide-in; think it's too distracting
        // this.showHideTimeline.from(
        //     this.buttonPrompt,
        //     settings.animation.showAvatarDuration,
        //     {
        //         ease: 'power1.out',
        //         width: this.buttonPrompt.clientWidth * 0.75,
        //     },
        //     0,
        // );

        this.showHideTimeline.from(
            this.buttonPrompt,
            settings.animation.showPromptDuration,
            {
                ease: 'power1.inOut',
                opacity: 0,
            },
            delay + settings.animation.showPromptDelay,
        );

        this.showHideTimeline.add(() => {
            this.showHideTimeline = null;

            // Clean up
            this.buttonPrompt.removeAttribute('style');
        });
    }

    hide(
        immediate = false,
        slowMo = false,
    ) {
        if (!this.isVisible) {
            return;
        }

        this.isVisible = false;

        // Stop any ongoing animation
        if (this.showHideTimeline) {
            this.showHideTimeline.progress(1);
        }

        // Add our "visible" class (should already be present)
        this.container.classList.add(settings.classNames.visible);

        // Animate transition
        this.showHideTimeline = gsap.timeline();
        if (slowMo) {
            this.showHideTimeline.timeScale(settings.animation.slowMoScale);
        }

        this.avatar.createHideAnimation(
            this.container,
            this.showHideTimeline,
            settings.animation.hideDuration,
            0,
        );

        this.showHideTimeline.to(
            this.buttonPrompt,
            settings.animation.hideDuration,
            {
                ease: 'power1.out',
                opacity: 0,
            },
            0,
        );

        this.showHideTimeline.add(() => {
            this.showHideTimeline = null;

            // Remove our "visible" class
            this.container.classList.remove(settings.classNames.visible);

            // Clean up
            this.buttonPrompt.removeAttribute('style');
        });
    }
}
